module.exports = __webpack_public_path__ + "img/hqzen3.d9f2eed4.png";